import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Row,
  Typography,
  Button,
  Spin,
  Form,
  message,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import getQueryParams from 'utils/getQueryParams';
import { defaultOptions } from 'utils/passwordRequirements';
import Password from 'components/Password';
import { onError } from 'utils/handlers';
import { restablecerContrasena } from 'api/usuarios/auth';
import Card from './components/Card';
import './index.scss';

const { Title } = Typography;

const RestablecerContrasena = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const codigo = getQueryParams('codigo', window.location.href);
  const [options, setOptions] = useState(defaultOptions);

  const onFormValuesChange = (changedValues, allValues) => {
    setPassword(allValues.password);
    const ops = [...options];
    if (allValues.password) {
      setOptions([
        {
          label: ops[0].label,
          checked: allValues.password && allValues.password.length >= 8,
          key: 1,
        },
        {
          label: ops[1].label,
          checked: /[A-ZÁÉÍÓÚÑ]/.test(allValues.password),
          key: 2,
        },
        {
          label: ops[2].label,
          checked: /[a-záéíóúñ]/.test(allValues.password),
          key: 3,
        },
        {
          label: ops[3].label,
          checked: !(/^[A-ZÁÉÍÓÚÑa-záéíóúñ0-9]+$/.test(allValues.password)),
          key: 4,
        },
        {
          label: ops[4].label,
          checked: /[0-9]/.test(allValues.password),
          key: 5,
        },
      ]);
    } else {
      setOptions([...defaultOptions]);
    }
    setTimeout(() => {
      if (allValues.passwordConfirm && changedValues.password) {
        form.validateFields(['password', 'passwordConfirm']);
      }
    });
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const response = await restablecerContrasena(codigo, {
        contrasena: values.password,
        contrasena_confirmacion: values.passwordConfirm,
      });
      if (response) {
        message.info(response.detail || 'Contraseña actualizada correctamente');
        setTimeout(() => history.push('/'), 2000);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rules = {
    password: [
      {
        validator: async () => {
          if (options.some((o) => !o.checked)) {
            throw new Error('La contraseña no cumple con los requisitos');
          }
        },
      },
    ],
    passwordConfirm: [
      {
        validator: async (rule, value) => {
          if (value && value !== password) {
            throw new Error('Las contraseñas no coinciden.');
          }
          if (options.some((o) => !o.checked)) {
            throw new Error('La contraseña no cumple con los requisitos');
          }
        },
      },
    ],
  };

  return (
    <Card>
      <Spin tip="Loading..." spinning={loading} style={{ width: '100%', height: '100%', justifyContent: 'center' }}>
        <Row style={{ width: '100%' }}>
          <Button
            type="link"
            className="auth-button"
            style={{ textAlign: 'left', padding: 0 }}
            onClick={() => history.push('/')}
          >
            <LeftOutlined />
            {' '}
            Volver
          </Button>
        </Row>
        <Title style={{ fontWeight: 'bold' }} level={3}>
          Restablecer contraseña
        </Title>
        <Form
          name="forgot-pwd-form"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onValuesChange={onFormValuesChange}
        >
          <Row gutter={[10, 10]}>
            <Password rules={rules} options={options} />
          </Row>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              htmlType="submit"
              shape="round"
              style={{
                backgroundColor: '#235161',
                color: '#D88F4F',
              }}
              block
              className="auth-button"
            >
              <span>Restablecer</span>
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default RestablecerContrasena;
